<div class="page-layout blank fullwidth p-12"  style="height: 1px; overflow-y: scroll; padding: 0 !important;   top: 1px;z-index: 9;">
  <div class="my-request">
    <div class="my-orders" *ngIf= "!isMobile">
      <h2 class="title">📋 My Requests</h2>
      <div class="search-and-create-req-div">
        <div class="search" >
            <!-- <input type="text"  [(ngModel)]="searchTerm"(keydown.enter)="filterRequest()" (input)="showClearIcon = searchTerm.length > 0"  (click)="hideScrollText = true"> -->
            <input type="text"
          [(ngModel)]="searchTerm"
          (keydown.enter)="filterRequest()"
          (input)="onInputChange()"
          (click)="toggleInputVisibility()">
            <span class="close-button" 
              *ngIf="showClearIcon" (click)="clearSearch()" class="clear-btn" >✖
            </span>
            <div  class="scroll-text-container-order-list" >
                <div class="SearchBarIcon">
                  <i class="material-icons-search">search</i>
                </div>
                <div
                  class="scroll-text"  *ngIf="!isInputVisible && !searchTerm && !isMobile"    >
                  <div id="animation-1" class="SearchBarAnimationText">Search By "Request ID"</div>
                  <div id="animation-2" class="SearchBarAnimationText">Search By "Registration Number"</div>
                  <div id="animation-3" class="SearchBarAnimationText">Search By "Car Make"</div>
                  <div id="animation-4" class="SearchBarAnimationText">Search By "Car Model"</div>
                  <div id="animation-5" class="SearchBarAnimationText">Search By "Fuel Type"</div>
                  <div id="animation-6" class="SearchBarAnimationText">Search By "Claim ID"</div>
                </div>
                <div
                  class="scroll-text"  *ngIf="!isInputVisible && !searchTerm && isMobile"    >
                  <div id="animation-1" class="SearchBarAnimationText"> "Request ID"</div>
                  <div id="animation-2" class="SearchBarAnimationText"> "Registration Number"</div>
                  <div id="animation-3" class="SearchBarAnimationText"> "Car Make"</div>
                  <div id="animation-4" class="SearchBarAnimationText"> "Car Model"</div>
                  <div id="animation-5" class="SearchBarAnimationText"> "Fuel Type"</div>
                  <div id="animation-6" class="SearchBarAnimationText"> "Claim ID"</div>
                </div>
            </div>
            <button class="search-request-btn" (click)="loadInstantDetails()"><mat-icon class="addd-mat-btn">add</mat-icon> 
              <span>Create Request</span></button>
            <!-- <button (click)="filterRequest()" *ngIf="isMobile">🔍</button> -->
            <span  (click)="sidecontainer()" *ngIf="isMobile" class="filterslist">
              <mat-icon style="color: black;">filter_list</mat-icon>
            Filters
            </span>
        </div>
      </div>
    </div>
<!-- ===================================================================MOBILE -->
     <div class="my-orders" *ngIf="isMobile">
      <h2 class="title">📋 My Requests</h2>
      <div class="search-and-create-req-div">
         <button class="search-request-btn" (click)="loadInstantDetails()"><mat-icon class="addd-mat-btn">add</mat-icon> 
              <span>Create Request</span></button>
            <!-- <button (click)="filterRequest()" *ngIf="isMobile">🔍</button> -->
      </div>
    </div>
    <div class="search-and-filter-in-mbl" *ngIf="isMobile">
      <div class="search" *ngIf="isMobile">
              <!-- <input type="text"  [(ngModel)]="searchTerm"(keydown.enter)="filterRequest()" (input)="showClearIcon = searchTerm.length > 0"  (click)="hideScrollText = true"> -->
              <input type="text"
            [(ngModel)]="searchTerm"
            (keydown.enter)="filterRequest()"
            (input)="onInputChange()"
            (click)="toggleInputVisibility()">
              <span class="close-button" 
                *ngIf="showClearIcon" (click)="clearSearch()" class="clear-btn" >✖
              </span>
              <div  class="scroll-text-container-order-list" >
                  <div class="SearchBarIcon">
                    <i class="material-icons-search">search</i>
                  </div>
                  <div
                    class="scroll-text"  *ngIf="!isInputVisible && !searchTerm && !isMobile"    >
                    <div id="animation-1" class="SearchBarAnimationText">Search By "Request ID"</div>
                    <div id="animation-2" class="SearchBarAnimationText">Search By "Registration Number"</div>
                    <div id="animation-3" class="SearchBarAnimationText">Search By "Car Make"</div>
                    <div id="animation-4" class="SearchBarAnimationText">Search By "Car Model"</div>
                    <div id="animation-5" class="SearchBarAnimationText">Search By "Fuel Type"</div>
                    <div id="animation-6" class="SearchBarAnimationText">Search By "Claim ID"</div>
                  </div>
                  <div
                    class="scroll-text"  *ngIf="!isInputVisible && !searchTerm && isMobile"    >
                    <div id="animation-1" class="SearchBarAnimationText"> "Request ID"</div>
                    <div id="animation-2" class="SearchBarAnimationText"> "Registration Number"</div>
                    <div id="animation-3" class="SearchBarAnimationText"> "Car Make"</div>
                    <div id="animation-4" class="SearchBarAnimationText"> "Car Model"</div>
                    <div id="animation-5" class="SearchBarAnimationText"> "Fuel Type"</div>
                    <div id="animation-6" class="SearchBarAnimationText"> "Claim ID"</div>
                  </div>
              </div>
      </div>
      <span  (click)="sidecontainer()" *ngIf="isMobile" class="filterslist">
                <mat-icon style="color: black;">filter_list</mat-icon>
              Filters
      </span>
    </div>
<!-- ===================================================================MOBILE END -->

    <div [ngClass]="isMobile? 'containerMobile' : 'container'" >
      <div class="toggle-head">
          <div class="toggle">
            <!-- <img src="../../../../assets/images/order-details/magic.jpg"> -->
            <div class="magic-switch">
              <div>✨ Magic Quote</div>
              <label class="switch">
                <input type="checkbox" [checked]="isOn" (change)="toggle($event)">
                <span class="slider">
                </span>
              </label>
            </div>
    </div>
      <div class="sidecontainer" *ngIf="!isMobile" [ngClass]="{'sidecontainerMobile': isMobile}">
        <div class="sidebar" [ngClass]="{'sidebarMobile': isMobile}">
          <div class="filter-and-clear">
            <h3 >⚙️ Filters</h3>
            <div *ngIf="hasAppliedFilters()" (click)="clearFilters()" class="clear-filters-btn">Clear all</div>
          </div>
          <!-- <hr /> -->
          <div class="clear">
            <div *ngIf="hasAppliedFilters()" class="applied-filters">
              <!-- <h4>Applied Filters</h4> -->
              <div *ngFor="let appliedFilter of appliedFilters" class="apply">
                <span>{{ appliedFilter.option.label }}</span>
                <mat-icon (click)="removeFilter(appliedFilter.requestTime, appliedFilter.option)" class="apply1">clear</mat-icon>
              </div>
            </div>
          </div>
             <div class="filter-sectionMobile" *ngIf="insurance?.length>=1">
            <h4 >Request Type</h4>
            <div *ngFor="let status of filters.insuranceStatus" class="filter-option">
              <label >
                <span>{{ status.label }}</span>
                <span class="radio-container">
                  <input type="radio" name="insuranceStatus" [(ngModel)]="selectedRequestInsurance" [value]="status.value" (change)="toggleSelection('insuranceStatus', status)" class="filter-radio">
                </span>
              </label>
            </div>
          </div>
          <div class="filter-sectionMobile">
            <h4 >Request Status</h4>
            <div *ngFor="let status of filters.requestStatus" class="filter-option">
              <label >
                <span>{{ status.label }}</span>
                <span class="radio-container">
                  <input type="radio" name="requestStatus" [(ngModel)]="selectedRequestStatus" [value]="status.value" (change)="toggleSelection('requestStatus', status)" class="filter-radio">
                </span>
              </label>
            </div>
          </div>
          <!-- <hr /> -->


          <div class="filter-sectionMobile">
            <h4 >Request Time</h4>
            <div *ngFor="let time of filters.requestTime">
              <div *ngIf="time.children; else singleRadio" class="filter-option">
                <h5>{{ time.label }}</h5>
                <div *ngFor="let child of time.children" class="filter-option">
                  <label>
                    <span>{{ child.label }}</span>
                    <span class="radio-container">
                      <input type="radio" name="requestTime" [(ngModel)]="selectedRequestTime" [value]="child.value" (change)="toggleSelection('requestTime', child)" class="filter-radio">
                    </span>
                  </label>
                </div>
              </div>
              <ng-template #singleRadio>
                <label class="filter-option">
                  <span>{{ time.label }}</span>
                  <span class="radio-container">
                    <input type="radio" name="requestTime" [(ngModel)]="selectedRequestTime" [value]="time.value" (change)="toggleSelection('requestTime', time)" class="filter-radio">
                  </span>
                </label>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
</div>
      <div  class="main-content" [ngClass]="{'main-contentMobile': isMobile}" >
        <!-- <div class="overlay" [class.visible]="isSidebarOpen" (click)="sidecontainer()"></div> -->
         <div style="display: flex;justify-content: space-between;margin-bottom: 14px;" *ngIf="!loading && filteredRequestList.length > 0">
          <div class="total-count">
            <p class="name">Total Requests</p>
            <p class="count">{{data.totalRequests}}</p>
          </div>
          <div class="total-count">
            <p class="name">Quotes Created</p>
            <p class="count">{{data.quoteReceived}}</p>
          </div>
          <div class="total-count">
            <p class="name">Quotes Approved</p>
            <p class="count">{{data.quoteApproved}}</p>
          </div>
          <div class="total-count">
            <p class="name">Orders Created</p>
            <p class="count">{{data.orderCreated}}</p>
          </div>
         </div>
        <div *ngIf="isSidebarOpen" class="sidecontainerMobile">
          <div class="sidebarMobile">
            
            <h3 ><i (click)="sidecontainer()" class="material-icons-arrow-back">arrow_back</i>Filters</h3>
            <!-- <hr /> -->

          <div class="clear">
            <div *ngIf="hasAppliedFilters()" class="applied-filters">
              <div style="display: flex; justify-content: space-between;">
                <h4>Applied Filters</h4>
                <div *ngIf="hasAppliedFilters()" (click)="clearFilters()" class="clear-filters-btn">Clear all</div>
              </div>
              <div *ngFor="let appliedFilter of appliedFilters" class="apply">
                <span>{{ appliedFilter.option.label }}</span>
                <mat-icon (click)="removeFilter(appliedFilter.requestTime, appliedFilter.option)" class="apply1">cancel</mat-icon>
              </div>
            </div>
          </div>
          <div  Class=filter-sectionMobile *ngIf="insurance?.length>=1">
            <h4 >Request Type</h4>
            <div *ngFor="let status of filters.insuranceStatus" class="filter-option">
              <label >
                <span>{{ status.label }}</span>
                <span class="radio-container">
                  <input type="radio" name="insuranceStatus" [(ngModel)]="selectedRequestInsurance" [value]="status.value" (change)="toggleSelection('insuranceStatus', status)" class="filter-radio">
                </span>
              </label>
            </div>
          </div>
          <div  Class=filter-sectionMobile>
            <h4 >Request Status</h4>
            <div *ngFor="let status of filters.requestStatus" class="filter-option">
              <label >
                <span>{{ status.label }}</span>
                <span class="radio-container">
                  <input type="radio" name="requestStatus" [(ngModel)]="selectedRequestStatus" [value]="status.value" (change)="toggleSelection('requestStatus', status)" class="filter-radio">
                </span>
              </label>
            </div>
          </div>
          <!-- <hr /> -->

          <div Class=filter-sectionMobile>
            <h4 >Request Time</h4>
            <div *ngFor="let time of filters.requestTime">
              <div *ngIf="time.children; else singleRadio" class="filter-option">
                <h5>{{ time.label }}</h5>
                <div *ngFor="let child of time.children" class="filter-option">
                  <label>
                    <span>{{ child.label }}</span>
                    <span class="radio-container">
                      <input type="radio" name="requestTime" [(ngModel)]="selectedRequestTime" [value]="child.value" (change)="toggleSelection('requestTime', child)" class="filter-radio">
                    </span>
                  </label>
                </div>
              </div>
              <ng-template #singleRadio>
                <label class="filter-option">
                  <span>{{ time.label }}</span>
                  <span class="radio-container">
                    <input type="radio" name="requestTime" [(ngModel)]="selectedRequestTime" [value]="time.value" (change)="toggleSelection('requestTime', time)" class="filter-radio">
                  </span>
                </label>
              </ng-template>
            </div>
          </div>
          <div class="applyFilter">
            <button (click)="sidecontainer()" class="applyFilterText">Apply Filter</button>
          </div>
        </div>
      </div>

      <!-- <div class="no-image-car">
        <div class="no-img" *ngIf="!loading && filteredRequestList.length === 0">
          <img [src]="emptyList" alt="No data available" />
          <h1 class="no-request-text">No Request Found</h1>
          <div class="eidt-text">Edit filter or go back to my request page</div>
          <button class="go-back-btn" (click)="clearFilters()" >Go to My Requests</button>
        </div>
      </div> -->

      <!-- =============================================================EMPTY STATE-UI============================================ -->
      <div class="request-list-empty-wrapper" *ngIf="!loading && filteredRequestList.length === 0"    >
          <!-- Illustration -->
          <div class="request-list-empty-illustration">
            <!-- <img src="../../../../assets/images/empty-request-list/req-list-empty.png" alt="No requests" /> -->
            <img src="../../../../assets/images/empty-lists-imgs/req-list-emty-with-bg.png" alt="No requests" />
          </div>
          <!-- Title -->
          <h2 class="request-list-empty-title">No requests yet</h2>
          <p class="request-list-empty-subtitle">
            Your part requests will appear here once you create one.
          </p>
          <!-- Info cards -->

          <div class="request-list-empty-cards">
            <div class="request-list-empty-card">
              <div class="request-list-empty-icon blue"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 3.02458H3C2.46957 3.02458 1.96086 3.23529 1.58579 3.61036C1.21071 3.98544 1 4.49414 1 5.02458V16.0246C1 16.555 1.21071 17.0637 1.58579 17.4388C1.96086 17.8139 2.46957 18.0246 3 18.0246H14C14.5304 18.0246 15.0391 17.8139 15.4142 17.4388C15.7893 17.0637 16 16.555 16 16.0246V11.0246M14.586 1.61058C14.7705 1.41956 14.9912 1.26719 15.2352 1.16237C15.4792 1.05756 15.7416 1.00238 16.0072 1.00008C16.2728 0.997768 16.5361 1.04837 16.7819 1.14893C17.0277 1.24949 17.251 1.398 17.4388 1.58579C17.6266 1.77357 17.7751 1.99688 17.8756 2.24267C17.9762 2.48846 18.0268 2.75182 18.0245 3.01738C18.0222 3.28294 17.967 3.54538 17.8622 3.78939C17.7574 4.03339 17.605 4.25408 17.414 4.43858L8.828 13.0246H6V10.1966L14.586 1.61058Z" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>              
              <h4>Create a request</h4>
              <p>Tell us what part you need</p>
            </div>
            <div class="request-list-empty-card">
              <div class="request-list-empty-icon green"><svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5H11M11 15V12M8 15H8.01M5 15H5.01M5 12H5.01M8 12H8.01M11 9H11.01M8 9H8.01M5 9H5.01M3 19H13C13.5304 19 14.0391 18.7893 14.4142 18.4142C14.7893 18.0391 15 17.5304 15 17V3C15 2.46957 14.7893 1.96086 14.4142 1.58579C14.0391 1.21071 13.5304 1 13 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19Z" stroke="#22C55E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              <h4>Get quotes</h4>
              <p>Receive competitive pricing</p>
            </div>
            <div class="request-list-empty-card">
              <div class="request-list-empty-icon yellow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L9 12L13 8M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              <h4>Track delivery</h4>
              <p>Monitor your order status</p>
            </div>
          </div>
          <!-- Actions -->
          <div class="request-list-empty-actions">
            <button class="request-list-empty-primary-btn"  (click)="loadInstantDetails()"> <mat-icon class="empty-add">add</mat-icon>  Create your first request</button>
            <button   class="request-list-empty-outline-btn"  >  Or edit existing filters </button>
            <!-- (click)="clearFilters()" -->
          </div>
          <!-- Footer -->
          <div class="request-list-empty-footer">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26686 1.45486C4.91012 1.4035 5.52077 1.15049 6.01186 0.73186C6.56652 0.259451 7.27129 0 7.99986 0C8.72843 0 9.4332 0.259451 9.98786 0.73186C10.4789 1.15049 11.0896 1.4035 11.7329 1.45486C12.4593 1.51292 13.1413 1.82782 13.6566 2.34313C14.1719 2.85843 14.4868 3.54043 14.5449 4.26686C14.5959 4.90986 14.8489 5.52086 15.2679 6.01186C15.7403 6.56652 15.9997 7.27129 15.9997 7.99986C15.9997 8.72843 15.7403 9.4332 15.2679 9.98786C14.8492 10.4789 14.5962 11.0896 14.5449 11.7329C14.4868 12.4593 14.1719 13.1413 13.6566 13.6566C13.1413 14.1719 12.4593 14.4868 11.7329 14.5449C11.0896 14.5962 10.4789 14.8492 9.98786 15.2679C9.4332 15.7403 8.72843 15.9997 7.99986 15.9997C7.27129 15.9997 6.56652 15.7403 6.01186 15.2679C5.52077 14.8492 4.91012 14.5962 4.26686 14.5449C3.54043 14.4868 2.85843 14.1719 2.34313 13.6566C1.82782 13.1413 1.51292 12.4593 1.45486 11.7329C1.4035 11.0896 1.15049 10.4789 0.73186 9.98786C0.259451 9.4332 0 8.72843 0 7.99986C0 7.27129 0.259451 6.56652 0.73186 6.01186C1.15049 5.52077 1.4035 4.91012 1.45486 4.26686C1.51292 3.54043 1.82782 2.85843 2.34313 2.34313C2.85843 1.82782 3.54043 1.51292 4.26686 1.45486ZM11.7069 6.70686C11.889 6.51826 11.9898 6.26566 11.9875 6.00346C11.9853 5.74126 11.8801 5.49045 11.6947 5.30504C11.5093 5.11963 11.2585 5.01446 10.9963 5.01219C10.7341 5.00991 10.4815 5.1107 10.2929 5.29286L6.99986 8.58586L5.70686 7.29286C5.51826 7.1107 5.26565 7.00991 5.00346 7.01219C4.74126 7.01446 4.49045 7.11963 4.30504 7.30504C4.11963 7.49045 4.01446 7.74126 4.01219 8.00346C4.00991 8.26566 4.1107 8.51826 4.29286 8.70686L6.29286 10.7069C6.48039 10.8943 6.7347 10.9996 6.99986 10.9996C7.26502 10.9996 7.51933 10.8943 7.70686 10.7069L11.7069 6.70686Z" fill="#3B82F6"/></svg>
              Trusted by 800+ garages for fast & reliable parts
          </div>
        </div>
<!-- =============================================================EMPTY STATE-UI ENDS============================================ -->

        <div *ngIf="!loading && filteredRequestList.length > 0">
          <div class="header" *ngFor="let list of filteredRequestList; let i = index">
            <div class="header-row">
              <div class="req-num-mag-and-statustag" *ngIf="!isMobile">
                <div class="request-number"> 
                  <svg style ="  width: 36px;    height: 36px;opacity: 1;  top: 196px; left: 333px; border-radius: 12px;    background: linear-gradient(90deg, #E8F2FF 100%, #D7F5FC 0%); padding: 7px;    box-shadow: 0px 1px 0px 0px #FFFFFF;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="req-id-and-claim-type-and-id">
                    <div class="req-id">Request ID# {{list.id}} <span *ngIf="list.requestDetails.isInsurance == 1 && insurance.length>=1 && !isMobile" class="insurance-is">🛡️ Insurance</span> <span *ngIf="list.requestDetails.isInsurance == 0 && insurance.length>=1 && !isMobile" class="insurance-is" style="background-color: #F4F6F8;">🧾 Non Insurance</span></div>
                    <div class="only-claim-id-type" *ngIf="list.requestDetails.claimNo">
                      <div *ngIf="list.requestDetails.claimNo" class="claim-di"> Claim ID: {{list.requestDetails.claimNo}}</div>
                      <div *ngIf="list.requestDetails.claimType" class="claim-type"> Claim Type: {{list.requestDetails.claimType}}</div>
                    </div>
                  </div>
                </div>
                <div class="header-top-row">
                  <!-- <div class="magic-quote-and-status">
                      <div class="quote-approved-container">
                        <div class="quote-approved" [ngClass]="{
                            'requested': getStatusMessage(list.statusDetails) === 'Requested',
                            'quote-received': getStatusMessage(list.statusDetails) === 'Quote Received',
                            'quote-approved': getStatusMessage(list.statusDetails) === 'Quote Approved',
                            'order-created': getStatusMessage(list.statusDetails) === 'Order Created'
                        }">{{ getStatusMessage(list.statusDetails) }}</div>
                    </div>
                    <div *ngIf="list.magicQuote==1" class="its-magic-class" > ✨ It's Magic</div>
                  </div> -->
                  <div class="magic-quote-and-status" [ngClass]="{'no-magic': list.magicQuote != 1}">
                    <div class="quote-approved-container">
                      <div class="quote-approved" [ngClass]="{
                          'requested': getStatusMessage(list.statusDetails) === '⏳ Requested',
                          'quote-received': getStatusMessage(list.statusDetails) === '💬 Quote Received',
                          'quote-approved': getStatusMessage(list.statusDetails) === '✅ Quote Approved',
                          'order-created': getStatusMessage(list.statusDetails) === '📦 Order Created',
                          'cancelled': getStatusMessage(list.statusDetails) === '❌ Cancelled'
                      }">
                        {{ getStatusMessage(list.statusDetails) }}
                      </div>
                    </div>

                    <div *ngIf="list.magicQuote == 1" class="its-magic-class">✨ It's Magic</div>
                  </div>

                </div>
              </div>
<!-- ===================================================================MOBILE===================== -->
              <div class="req-num-mag-and-statustag" *ngIf="isMobile">
                <div class="request-number"> 
                  <svg style ="  width: 36px;    height: 36px;opacity: 1;  top: 196px; left: 333px; border-radius: 12px;    background: linear-gradient(90deg, #E8F2FF 100%, #D7F5FC 0%); padding: 7px;    box-shadow: 0px 1px 0px 0px #FFFFFF;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="req-id-and-claim-type-and-id">
                    <div class="req-id">Request ID# {{list.id}} <div *ngIf="list.requestDetails.isInsurance == 1 && insurance.length>=1 && !isMobile" class="insurance-is">🛡️ Insurance</div></div>
                    <div class="only-claim-id-type" *ngIf="list.requestDetails.claimNo">
                      <div *ngIf="list.requestDetails.claimNo" class="claim-di"> Claim ID: {{list.requestDetails.claimNo}}</div>
                      <div *ngIf="list.requestDetails.claimType" class="claim-type"> Claim Type: {{list.requestDetails.claimType}}</div>
                    </div>
                  </div>
                </div>
                <div class="header-top-row">
                  <!-- <div class="magic-quote-and-status">
                      <div class="quote-approved-container">
                        <div class="quote-approved" [ngClass]="{
                            'requested': getStatusMessage(list.statusDetails) === 'Requested',
                            'quote-received': getStatusMessage(list.statusDetails) === 'Quote Received',
                            'quote-approved': getStatusMessage(list.statusDetails) === 'Quote Approved',
                            'order-created': getStatusMessage(list.statusDetails) === 'Order Created'
                        }">{{ getStatusMessage(list.statusDetails) }}</div>
                    </div>
                    <div *ngIf="list.magicQuote==1" class="its-magic-class" > ✨ It's Magic</div>
                  </div> -->
                  <div class="magic-quote-and-status" [ngClass]="{'no-magic': list.magicQuote != 1}">
                     <span *ngIf="list.requestDetails.isInsurance == 1 && insurance.length>=1 && isMobile" class="insurance-is">🛡️ Insurance</span> 
                     <span *ngIf="list.requestDetails.isInsurance == 0 && insurance.length>=1 && isMobile" class="insurance-is" style="background-color: #F4F6F8;">🧾 Non Insurance</span>
                    <div class="quote-approved-container">
                      <div class="quote-approved" [ngClass]="{
                          'requested': getStatusMessage(list.statusDetails) === '⏳ Requested',
                          'quote-received': getStatusMessage(list.statusDetails) === '💬 Quote Received',
                          'quote-approved': getStatusMessage(list.statusDetails) === '✅ Quote Approved',
                          'order-created': getStatusMessage(list.statusDetails) === '📦 Order Created',
                          'cancelled': getStatusMessage(list.statusDetails) === '❌ Cancelled'
                      }">
                        {{ getStatusMessage(list.statusDetails) }}
                      </div>
                    </div>

                    <div *ngIf="list.magicQuote == 1" class="its-magic-class">✨ It's Magic</div>
                  </div>

                </div>
              </div>
<!-- ===================================================================MOBILE END===================== -->

              <div style="padding: 10px 0px;  border-bottom: 1px solid #E6EEFC;display: flex; justify-content: space-between;">
                <div>
                <div class="order-icon" *ngIf="list.requestDetails.make">
                    <img [src]="getMakeImageUrl(list.requestDetails.make)" alt="Icon">  
                    <div class="make-icon-fuel-type-model" >
                      {{list.requestDetails.model}}, {{list.requestDetails.fuelType}}
                    </div>              
                </div>
                <div class="request-info">
                    <ng-container *ngIf="list.requestDetails.model || list.requestDetails.fuelType; else noDetails">
                      <div class=" variant">
                        {{list.requestDetails.variant}}   [{{list.requestDetails.manufacturingYear}}] 
                      </div>
                    </ng-container>
                    <div class="registration-number">· {{list.requestDetails.regNo}}</div>
                    <ng-template #noDetails>
                      <div class="universal-text">Universal</div>
                    </ng-template>
              </div>
                <div class="request-card">
                  <div class="car-img" *ngIf="!list.requestDetails.make">
                    <div class="car-image-wrapper">
                      <mat-icon class="car-image">directions_car</mat-icon>
                    </div>  
                    <!-- <div class="request-info">
                      <div class="request-number">Request ID# {{list.id}}</div>
                      <div class="universal-text">Universal</div>
                    </div> -->
                  </div> 
                </div>
              </div>
              <div class="menu-container"  *ngIf="getStatusMessage(list.statusDetails)=='✅ Quote Approved' || getStatusMessage(list.statusDetails) === '💬 Quote Received' || getStatusMessage(list.statusDetails) === '⏳ Requested'|| getStatusMessage(list.statusDetails) === '📦 Order Created'">
                <p class="dots" (click)="toggleEditMenu(i, $event)">⋯</p>
              </div>
              </div>
          <div *ngIf="openEditIndex === i"
              class="edit-menu">

            <p (click)="addMoreItems(list.requestDetails)" style="padding-right: 13px;"><img src="../../../../assets/images/add-more.png" style="width: 14%;"> Add More Items</p>
            <p (click)="editRequest(list.id)" *ngIf="insurance?.length>=1">📝 Edit Request Type</p>

          </div>

        </div>

            <div class="header-row1">
              <div *ngIf="list.statusDetails">
                <!-- *ngFor="let status of filters.requestStatus; index as i" -->
                <div class="num-of-item-with-clain-id-type" >
                  <div style="display: inline; width: 90%;">
                    <div class="items-rqstd-cls">Items Requested</div>
                    <!-- <div *ngIf="list.statusDetails" class="no-of-items">  {{ getTotalItems(list.statusDetails) }} {{ getTotalItems(list.statusDetails) === 1 ? 'item' : 'items' }}</div> -->
                    <div *ngIf="list.requestDetails.itemNames" class="no-of-items">  {{ list.requestDetails.itemNames }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="header-row2" *ngIf="!isMobile">
              <div class="request-date">Requested on: {{list.requestDetails.requestedDate | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}</div>
              <div class="share-details-req-list" (click)="shareRequestViaWhatsApp(list)" *ngIf="getStatusMessage(list.statusDetails) != '❌ Cancelled'">
                <mat-icon>share</mat-icon>
                <div class="req-list-share-btn" >Share Details</div>
              </div>
              <a class="view-btn" (click)="navigateToDetails(list.id,getStatusMessage(list.statusDetails))" >
                <mat-icon style="color: white;">keyboard_arrow_right</mat-icon>
                <div class="view">View Details</div>
              </a>
            </div>
            <div class="header-row2" *ngIf="isMobile">
              <div class="request-date">Requested on: {{list.requestDetails.requestedDate | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}</div>
              <div class="share-details-req-list" (click)="shareRequestViaWhatsApp(list)" *ngIf="getStatusMessage(list.statusDetails) != '❌ Cancelled'">
                <mat-icon>share</mat-icon>
                <!-- <div class="req-list-share-btn" >Share Details</div> -->
              </div>
              <a class="view-btn" (click)="navigateToDetails(list.id,getStatusMessage(list.statusDetails))" >
                <mat-icon style="color: white;">keyboard_arrow_right</mat-icon>
                <div class="view">View</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
<div #intstantorder></div>
 <div class="overlay" [class.visible]="isInsurance" (click)="goBackList()" *ngIf="isInsurance && !isMobile"></div>

<div class="sidebar-container" *ngIf="isInsurance">
  <div class="create-req">
    <div *ngIf="!openEdit"><i (click)="goBackList()" >arrow_back</i>
      Create Request
    </div>
    <div *ngIf="openEdit"><i (click)="goBackList()" >arrow_back</i>
      Update Request Type
    </div>
    <div class="info" (click)="showPopup()">
      ?
    </div>
  </div>
  
  <div class="overflow">
  <h3 class="choose">Choose Request Type</h3>

  <div class="options">
    <div class="card" [ngClass]="{active: selectedType === 'insurance'}"
         (click)="selectType('insurance')">
      <div class="icon">🛡️</div>
      <div>
        <h4>Insurance</h4>
        <p>For insurance claims with insurer billing</p>
      </div>
    </div>

    <div class="card" [ngClass]="{active: selectedType === 'non-insurance'}"
         (click)="selectType('non-insurance')">
      <div class="icon">🧾</div>
      <div>
        <h4>Non-Insurance</h4>
        <p>For retail/regular jobs</p>
      </div>
    </div>
  </div>

   <div class="insurance-section" *ngIf="selectedType === 'insurance' && insurance.length>1">
  <h4 class="subtitle">Select Insurance Company</h4>
  <input
    type="text"
    class="search-box"
    placeholder="Search insurer (e.g., ICICI, HDFC)"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchChange()"
  />

  <div class="company-grid">
    <div
      class="company-card"
      *ngFor="let company of filteredList"
      (click)="selectCompany(company)"
      [ngClass]="{ selected: selectedCompany === company.insuranceGarageKey }"
    >
      <!-- <div class="circle"></div> -->
      <p>{{ company.insuranceGarageName }}</p>
    </div>
  </div>
</div>

</div>

<div class="error-div">
      <p class="error" *ngIf="showError">
    Please choose Insurance or Non-Insurance.
  </p>     
   <p class="error" *ngIf="showError1">
    Please select an insurance company.
  </p>
  <div class="actions" *ngIf="openEdit">
    <button class="primary-btn"
        [class.active]="isContinueActive"
        (click)="updateInsurance()" style="width: 97%;">
      Update
    </button>

  </div>
  <div class="actions" *ngIf="!openEdit">
    <button class="secondary-btn" (click)="skip()">Skip & decide later</button>
    <button class="primary-btn"
        [class.active]="isContinueActive"
        (click)="continue()">
      Continue
    </button>

  </div>
  </div>
</div>
<div class="popup-overlay" *ngIf="showPopupinfo">
  <div class="popup-box">
    <h3>Which option to choose?</h3>
    <p>
      <strong>Insurance:</strong><br>
      If work is under insurance claim. We'll bill the insurer.
    </p>
    <p>
      <strong>Non-Insurance:</strong><br>
      For regular/retail jobs. We'll bill the garage.
    </p>
    <button (click)="closePopup()">Got it</button>
  </div>
</div>

